// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { stringMustBeNumber } from 'validators/common/simple'
import { MUST_BE_GREATER_THAN_ZERO } from 'errors'

// X > 0
const stringMustBeGreaterThanZero = v => (
  stringMustBeNumber(v) ||
  v.length && !(+v > 0) && MUST_BE_GREATER_THAN_ZERO
)

export default stringMustBeGreaterThanZero
